<template>
  <v-container fluid ma-0 pa-0 px-4 id="jobs">
    <div class="fixed-header" :class="{ mobile: $vuetify.breakpoint.smAndDown }">
      <!-- if has summary fields add class 'with-summary' -->
      <v-layout align-center fill-height class="fixed-header-wrapper">
        <v-flex shrink class="text-truncate" pr-4>
          <v-tooltip color="secondary" bottom>
            <template v-slot:activator="{ on }">
              <h2 v-on="on" class="p-relative text-truncate">Jobs</h2>
            </template>
            <span>Jobs</span>
          </v-tooltip>
          <h4 class="pt-1 sub-header">View all Caseblocks jobs</h4>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </div>
    <v-container mt-4 pa-0 fluid class="elevation-2 rounded-3 on-white-background" style="background-color: white">
      <v-tabs id="jobs-tabs" show-arrows color="white" slider-color="primary" grow v-model="currentTab">
        <v-tab ripple>My Jobs</v-tab>
        <v-tab v-if="isAdmin" ripple>All Jobs</v-tab>
        <v-tab-item>
          <v-divider></v-divider>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 px-4 pb-3 mb-3>
                <v-layout row fluid wrap class="mb-2">
                  <v-btn @click="refresh()" id="btn_refresh" class="ml-0 mr-2 mb-0" color="secondary"> <v-icon>refresh</v-icon>&emsp;Refresh </v-btn>
                  <v-spacer></v-spacer>
                  <div class="mt-0 mr-3" style="min-width: 240px">
                    <v-select
                      v-model="selectedJobType"
                      :items="jobTypeOptions"
                      label="Job type"
                      hide-details
                      solo
                      flat
                    ></v-select>
                  </div>
                  <div class="mt-0">
                    <v-radio-group row v-model="filter" class="d-inline-block mt-1">
                      <v-radio value="All" color="secondary">
                        <template slot="label">
                          <div class="secondary--text">All jobs</div>
                        </template>
                      </v-radio>
                      <v-radio value="Failed" color="error">
                        <template slot="label">
                          <div class="error--text">Failed</div>
                        </template>
                      </v-radio>
                      <v-radio value="Killed" color="error">
                        <template slot="label">
                          <div class="error--text">Killed</div>
                        </template>
                      </v-radio>
                      <v-radio value="Completed" color="success">
                        <template slot="label">
                          <div class="success--text">Completed</div>
                        </template>
                      </v-radio>
                      <v-radio value="Running" color="tertiary">
                        <template slot="label">
                          <div class="tertiary--text">In Progress</div>
                        </template>
                      </v-radio>
                      <v-radio value="Pending" color="secondary">
                        <template slot="label">
                          <div class="secondary--text">Pending</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </div>
                </v-layout>
                <Loading :isLoading="isLoading">
                  <CBPagination v-model="paginationPage" :total-pages="pageTotal" :disabled="isLoading"></CBPagination>
                  <JobItem v-for="(job, index) in myJobs" :key="job.id" :id="String(job.id)" :currentUser="currentUser" :initialJob="job"> </JobItem>
                  <CBPagination class="mt-3" v-model="paginationPage" :total-pages="pageTotal" :disabled="isLoading"></CBPagination>
                </Loading>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-divider></v-divider>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 px-4 pb-3 mb-3>
                <v-layout row fluid wrap class="mb-2">
                  <v-btn @click="refresh()" id="btn_refresh" class="ml-0 mr-2 mb-0" color="secondary"> <v-icon>refresh</v-icon>&emsp;Refresh </v-btn>
                  <v-spacer></v-spacer>
                  <div class="mt-2 mr-3" style="min-width: 240px">
                    <v-select
                      v-model="selectedJobType"
                      :items="jobTypeOptions"
                      label="Job type"
                      hide-details
                      solo
                      flat
                    ></v-select>
                  </div>
                  <div class="mt-2">
                    <v-radio-group row v-model="filter" class="d-inline-block mr-3 mt-0">
                      <v-radio value="All" color="secondary">
                        <template slot="label">
                          <div class="secondary--text">All jobs</div>
                        </template>
                      </v-radio>
                      <v-radio value="Failed" color="error">
                        <template slot="label">
                          <div class="error--text">Failed</div>
                        </template>
                      </v-radio>
                      <v-radio value="Killed" color="error">
                        <template slot="label">
                          <div class="error--text">Killed</div>
                        </template>
                      </v-radio>
                      <v-radio value="Completed" color="success">
                        <template slot="label">
                          <div class="success--text">Completed</div>
                        </template>
                      </v-radio>
                      <v-radio value="Running" color="tertiary">
                        <template slot="label">
                          <div class="tertiary--text">In Progress</div>
                        </template>
                      </v-radio>
                      <v-radio value="Pending" color="secondary">
                        <template slot="label">
                          <div class="secondary--text">Pending</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </div>
                </v-layout>
                <Loading :isLoading="isLoading">
                  <CBPagination v-model="paginationPage" :total-pages="pageTotal" :disabled="isLoading"></CBPagination>
                  <JobItem v-for="(job, index) in allJobs" :key="job.id" :id="String(job.id)" :currentUser="currentUser" :initialJob="job"></JobItem>
                  <CBPagination class="mt-3" v-model="paginationPage" :total-pages="pageTotal" :disabled="isLoading"></CBPagination>
                </Loading>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </v-container>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"
import JobItem from "@/components/jobs/JobItem.vue"
import CBPagination from "@/components/shared/CBPagination.vue"
import { getJobTypes, subscribeToJobStatsUpdates, unsubscribeFromJobStatsUpdates } from "@/provider/jobs"
import { jobsUiDebugLog } from "@/utils/jobsUiDebug"
import { mapState } from "vuex"
import Vue from "vue"

const JOBS_PAGE_SIZE = 10

export default {
  name: "Jobs",
  components: { Loading, JobItem, CBPagination },
  mounted() {
    Vue.store.dispatch("setPageTitle", "Jobs")
    const pageFromQuery = this.$route.query.page && parseInt(this.$route.query.page, 10)
    if (pageFromQuery >= 1) {
      this.paginationPage = pageFromQuery
    }
    this.loadJobTypes()
    this.subscribeJobStatsChannel()
    this._onGraphqlWsConnected = () => {
      jobsUiDebugLog("Jobs.vue:ws_connected_resubscribe", {})
      this.subscribeJobStatsChannel()
    }
    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener("cb-graphql-ws-connected", this._onGraphqlWsConnected)
    }
  },
  beforeDestroy() {
    jobsUiDebugLog("Jobs.vue:beforeDestroy", {})
    if (typeof window !== "undefined" && window.removeEventListener && this._onGraphqlWsConnected) {
      window.removeEventListener("cb-graphql-ws-connected", this._onGraphqlWsConnected)
    }
    unsubscribeFromJobStatsUpdates()
  },
  data: () => {
    return {
      paginationPage: 1,
      dialogLog: false,
      dialogKill: false,
      refreshing: false,
      currentUserJobs: false,
      currentTab: "",
      filter: "All",
      selectedJobType: "All types",
      jobTypes: [],
    }
  },
  watch: {
    async currentTab() {
      this.currentUserJobs = this.currentTab === 0
      await this.loadJobTypes()
      this.refresh()
    },
    paginationPage() {
      this.updateUrlWithPage()
      this.refresh()
    },
    "$route"(to) {
      const pageFromQuery = to.query.page && parseInt(to.query.page, 10)
      if (pageFromQuery >= 1 && pageFromQuery !== this.paginationPage) {
        this.paginationPage = pageFromQuery
      }
    },
    filter() {
      this.paginationPage = 1
      this.refresh()
    },
    selectedJobType() {
      this.paginationPage = 1
      this.refresh()
    },
    pageTotal(newTotal) {
      if (newTotal >= 1 && this.paginationPage > newTotal) {
        this.paginationPage = newTotal
      }
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.currentUser.loading,
      accountJobs: (state) => state.accounts.jobs.allJobs,
      userJobs: (state) => state.accounts.jobs.myJobs,
      currentUser: (state) => state.currentUser.me,
      pageTotal: (state) => state.accounts.jobs.pages,
      isAdmin: (state) => state.currentUser.isAccountAdmin,
    }),
    pageSize() {
      return JOBS_PAGE_SIZE
    },
    jobTypeOptions() {
      return ["All types"].concat(this.jobTypes)
    },
    isLoading() {
      return this.loading || this.refreshing
    },
    myJobs() {
      return this.userJobs
    },
    allJobs() {
      return this.accountJobs
    },
  },
  methods: {
    subscribeJobStatsChannel() {
      jobsUiDebugLog("Jobs.vue:subscribe", { note: "enable logs: localStorage.setItem('CB_JOBS_UI_DEBUG','1')" })
      subscribeToJobStatsUpdates((update) => {
        jobsUiDebugLog("Jobs.vue:subscription_callback", {
          jobId: update.jobId,
          succeeded: update.succeeded,
          failed: update.failed,
          jobStatus: update.jobStatus,
        })
        this.$store.commit("patchJobFromSubscription", { update })
      })
    },
    updateUrlWithPage() {
      const query = { ...this.$route.query }
      if (this.paginationPage > 1) {
        query.page = this.paginationPage.toString()
      } else {
        delete query.page
      }
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ path: this.$route.path, query })
      }
    },
    async loadJobTypes() {
      const types = await getJobTypes(this.currentUserJobs)
      this.jobTypes = types || []
      if (this.jobTypes.indexOf(this.selectedJobType) === -1) {
        this.selectedJobType = "All types"
      }
    },
    async refresh() {
      this.refreshing = true
      jobsUiDebugLog("Jobs.vue:refresh:start", {
        page: this.paginationPage,
        myJobsOnly: this.currentUserJobs,
        filter: this.filter,
        jobType: this.selectedJobType,
      })
      if (!this.isAdmin) {
        this.currentUserJobs = true
      }
      let paramFilter = this.filter
      if (paramFilter === "All") {
        paramFilter = null
      }
      const paramJobType = this.selectedJobType === "All types" ? null : this.selectedJobType
      const variables = { page: this.paginationPage - 1, pageSize: this.pageSize, myJobsOnly: this.currentUserJobs, jobStatus: paramFilter, jobType: paramJobType }
      await this.$store.dispatch("getJobsPage", variables)
      this.refreshing = false
      jobsUiDebugLog("Jobs.vue:refresh:done", { myJobsOnly: this.currentUserJobs })
    },
  },
}
</script>

<style>
.failed .v-icon {
  color: #db444d;
  opacity: 1;
}

.progress .v-icon {
  color: #f19916;
  opacity: 1;
}

.complete .v-icon {
  color: #0d9460;
  opacity: 1;
}

.job {
  width: 100%;
}

.job .details {
  width: calc(100% - 290px);
  display: inline-block;
  vertical-align: top;
  padding: 16px 0 16px 58px;
}

.job.md .details {
  width: calc(100% - 250px);
}

.job.sm .details {
  width: calc(100% - 0px);
  display: inline-block;
  padding: 20px 0 20px 58px;
}

.job .actions {
  width: 290px;
  display: inline-block;
  vertical-align: middle;
  text-align: right;
  padding: 20px 0;
}

.job.md .actions {
  width: 250px;
}

.job.sm .actions {
  width: 100%;
  text-align: left !important;
  margin-top: 0px;
  padding: 0px 20px 20px 90px;
}

.job .actions .btns {
  float: right;
  margin: 3px 0 0 0;
}

.job.md .actions .btns {
  display: block;
  float: right;
  width: 100%;
  margin: 3px 0 0 0;
  text-align: right;
}

.job.sm .actions .btns {
  float: right;
  width: auto;
  margin: 3px 0 0 0;
  text-align: left;
}

.job .progress {
  float: right;
  margin-left: 16px;
}

.job.md .progress {
  width: 100%;
}

.job.sm .progress {
  width: auto;
}

.job.md .actions .btns {
  display: block;
  float: left;
  margin: 3px 0 0 0;
}
</style>
